import http from "@http"

//列表  不分页
export function getCircuitAdministerList(data) {
    return http({
        url: '/lskj-data/api/data/circuitAdminister/list',
        method: "post",
        data
    })
}
//列表  分页
export function getCircuitAdministerAll(data) {
    return http({
        url: '/lskj-data/api/data/circuitAdminister/all',
        method: "post",
        data
    })
}

//查询单条
export function circuitAdministerById(data) {
    return http({
        url: `/lskj-data/api/data/circuitAdminister/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function circuitAdministerAdd(data) {
    return http({
        url: '/lskj-data/api/data/circuitAdminister/add',
        method: "post",
        data
    })
}

//修改
export function updetecirCuitAdminister(data) {
    return http({
        url: `/lskj-data/api/data/circuitAdminister`,
        method: "put",
        data
    })
}
//删除
export function deletecirCuitAdminister(data) {
    return http({
        url: `/lskj-data/api/data/circuitAdminister?ids=${data.ids}`,
        method: "delete",
        data
    })
}

// 数据同步
export function commonCogradient(data) {
    return http({
        url: '/lskj-document/api/document/common/cogradient',
        method: "post",
        data
    })
}
// 数据同步
export function getHistoryDataTime(data) {
    return http({
        url: '/lskj-business/api/business/dataCommon/getHistoryDataTime',
        method: "post",
        data
    })
}